import ProductListing from '../../containers_v2/products/productListing';
import AssortmentListing from '../../containers_v2/products/assortmentListing';
import * as React from 'react';
import { Translate } from 'react-localize-redux';
import { Route } from '../Routes';
import AssortmentListingV3 from '../../containers_v2/products/assortmentV3';

const ProductsRoutesV2 = (): Route[] => [
	{
		component: ProductListing,
		path: '/products-v2',
		name: <Translate id="catalog" />,
		key: 'catalog',
		sectionKey: 'catalog',
		title: 'Products',
		subTitle: 'Products',
		restricted: false,
		exact: true,
		menu: false,
		subMenu: 'products',
		permission: ['ViewCatalog'],
		beta: true
	},
	{
		component: AssortmentListing,
		path: '/assortments-v2',
		title: 'assortments',
		subTitle: 'assortments',
		restricted: false,
		exact: true,
		subMenu: 'assortments',
		key: 'assortments',
		permission: ['ViewCatalog'],
		beta: true
	},
	{
		component: AssortmentListingV3,
		path: '/multi-dimension',
		title: 'assortments',
		subTitle: 'assortments',
		restricted: false,
		exact: true,
		subMenu: 'assortments',
		key: 'assortments',
		permission: ['ViewCatalog'],
		beta: true
	},
	
];

export default ProductsRoutesV2;
